import { render, staticRenderFns } from "./StudyTest.vue?vue&type=template&id=c1e6473e&scoped=true"
import script from "./StudyTest.vue?vue&type=script&lang=js"
export * from "./StudyTest.vue?vue&type=script&lang=js"
import style0 from "./StudyTest.vue?vue&type=style&index=0&id=c1e6473e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e6473e",
  null
  
)

export default component.exports